module.exports = __webpack_public_path__ + "img/logo.fc4f6352.png";